export { default } from './colors'
